'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tables = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Table = require('antd/es/Table');

var _Table2 = _interopRequireDefault(_Table);

var _reactFileIcon = require('react-file-icon');

var _reactFileIcon2 = _interopRequireDefault(_reactFileIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var source = {
  'text/plain': '',
  'stylesheet': 'css',
  'font': '',
  'xhr': '',
  'image': /(jpg|jpeg|bmp|png|svg|gif)/,
  'javascript': 'javascript',
  'json': 'json',
  'document': 'html'
};

var columns = [/* {
               title: 'ID',
               dataIndex: 'id',
               key: 'id',
               width: 20
               }, */{
  title: 'Name',
  dataIndex: 'name',
  width: 200,
  key: 'name',
  render: function render(val, record) {
    var value = val[0];
    var fileType = val[1];
    var arr = value.split('/');
    var name = arr.pop() || '';
    var path = arr.join('/');

    if (!path) {
      name = value;
    }
    name = decodeURIComponent(name);

    if (path.length > 50) {
      path = path.substr(0, 50) + '...';
    }

    if (name.length > 50) {
      name = name.substr(0, 50) + '...';
    }

    return _react2.default.createElement(
      'div',
      { className: 'req-path', title: val[0] },
      _react2.default.createElement('img', { src: 'icons/' + fileType + '.png' }),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          { className: 'name' },
          name
        ),
        _react2.default.createElement(
          'p',
          { className: 'path' },
          path
        )
      )
    );
  }
}, {
  title: 'Method',
  dataIndex: 'method',
  key: 'method',
  width: 45
}, {
  title: 'Status',
  dataIndex: 'status',
  key: 'status',
  width: 45
}, {
  title: 'Scheme',
  dataIndex: 'protocol',
  key: 'protocol',
  width: 45
}, {
  title: 'Domain',
  dataIndex: 'address',
  key: 'address',
  width: 80
}, {
  title: 'Target Address',
  dataIndex: 'targetAddress',
  key: 'targetAddress',
  width: 70
}, {
  title: 'Target Path',
  dataIndex: 'targetPath',
  key: 'targetPath',
  width: 100,
  render: function render(val, record) {
    var originVal = val;

    if (val.length > 80) {
      val = val.substr(0, 80) + '...';
    }

    return _react2.default.createElement(
      'div',
      { className: 'req-path', title: originVal },
      val
    );
  }
}, {
  title: 'Type',
  dataIndex: 'type',
  key: 'type',
  width: 50
}, {
  title: 'Size',
  dataIndex: 'size',
  key: 'size',
  width: 50,
  sorter: function sorter(a, b) {
    return a.size - b.size;
  },
  render: function render(val, record) {
    return getSizeLabel(val);
  }
}, {
  title: 'Time',
  dataIndex: 'time',
  key: 'time',
  width: 50,
  sorter: function sorter(a, b) {
    return a.time - b.time;
  },
  render: function render(val, record) {
    return getTimeLabel(val);
  }
}];

var Tables = exports.Tables = function Tables(props) {
  var dataSource = props.data && props.data.map(function (t, index) {
    var id = t.id,
        _t$resHeaders = t.resHeaders,
        resHeaders = _t$resHeaders === undefined ? {} : _t$resHeaders,
        _t$socketData = t.socketData,
        socketData = _t$socketData === undefined ? '' : _t$socketData,
        statusCode = t.statusCode,
        url = t.url,
        method = t.method,
        hostname = t.hostname,
        port = t.port,
        path = t.path,
        time = t.time,
        fileType = t.fileType;

    var contentType = resHeaders['content-type'] || '';
    var length = resHeaders['content-length'] || socketData.length;

    if (t.type === 'connect') {
      return {
        key: id,
        name: ['UNKNOW', 'ssl-error'],
        id: id,
        method: 'CONNECT',
        protocol: 'HTTPS',
        status: '',
        address: hostname + ':' + port,
        targetAddress: '',
        targetPath: '',
        type: '',
        size: 'N/A',
        time: 'N/A'
      };
    }

    var host = url.host,
        _url$protocol = url.protocol,
        protocol = _url$protocol === undefined ? '' : _url$protocol;


    return {
      key: id,
      name: [t.url.path, fileType],
      id: id,
      method: method,
      protocol: protocol.replace(':', '').toUpperCase(),
      status: statusCode,
      address: host,
      targetAddress: hostname + (port ? ':' + port : ''),
      targetPath: path || '',
      type: getContentType(contentType),
      size: length, // getSizeLabel(length),
      time: time // getTimeLabel(time)
    };
  });

  return _react2.default.createElement(_Table2.default, {
    bordered: true,
    className: 'req-table',
    dataSource: dataSource,
    pagination: false,
    columns: columns,
    onRowClick: props.showRequestDetail,
    scroll: { y: window.innerHeight - 123 },
    rowClassName: function rowClassName(record, index) {
      return 'request-row' + (props.currIndex === record.id ? ' active' : '');
    }
  });
};

function getContentType(contentType) {
  for (var key in source) {
    var types = source[key];

    if (types) {
      if (typeof types === 'string') {
        if (contentType.indexOf(types) !== -1) {
          return key;
        }
      } else if (typeof types.test === 'function') {
        if (types.test(contentType)) {
          return key;
        }
      }
    }
  }

  return '';
}

function getSizeLabel(num) {
  var k = num / 1024;
  var m = k / 1024;

  if (m > 1) {
    return m.toFixed(2) + ' MB';
  } else if (k > 1) {
    return k.toFixed(2) + ' KB';
  } else {
    return num + ' B';
  }
}

function getTimeLabel(time) {
  var s = time / 1000;

  if (s > 1) {
    return s.toFixed(1) + ' s';
  } else {
    return time + ' ms';
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/page/table.js
// module id = 195
// module chunks = 0